var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLeftIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 17.9258C15.0928 17.5431 15.0928 16.9225 14.71 16.5397L10.2781 12.1078L14.7129 7.6729C15.0957 7.29015 15.0957 6.66958 14.7129 6.28682C14.3302 5.90407 13.7096 5.90407 13.3268 6.28682L8.1989 11.4147C8.0151 11.5985 7.9119 11.8478 7.9119 12.1078C7.9119 12.3677 8.0151 12.617 8.1989 12.8008L13.3239 17.9258C13.7067 18.3086 14.3273 18.3086 14.71 17.9258Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.71 17.9258C15.0928 17.5431 15.0928 16.9225 14.71 16.5397L10.2781 12.1078L14.7129 7.6729C15.0957 7.29015 15.0957 6.66958 14.7129 6.28682C14.3302 5.90407 13.7096 5.90407 13.3268 6.28682L8.1989 11.4147C8.0151 11.5985 7.9119 11.8478 7.9119 12.1078C7.9119 12.3677 8.0151 12.617 8.1989 12.8008L13.3239 17.9258C13.7067 18.3086 14.3273 18.3086 14.71 17.9258Z",
    fill: "currentColor",
    fillOpacity: 0.56
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftIcon);
export default __webpack_public_path__ + "static/media/LeftIcon.9da9c17efc069c927d4b07e1060eac14.svg";
export { ForwardRef as ReactComponent };